import { INurtureCampaignRuleStatistic } from "../nurtureCampaign/NurtureCampaignStatistics";
import { IBaseEntity, UpdateOmitBaseEntityKeys } from "./../system/BaseEntity";
import { IEmailSettingsCtaBanner } from "./EmailSettingsCTABanner";
import { IEmailSettingsMarketingGroup } from "./EmailSettingsMarketingGroup";

export enum NewsletterSchedule {
  FirstDay,
  LastDay,
  SpecificDay,
}

export interface SendTestEmail {
  email: string;
}

export interface INewsletterArticleCategory extends IBaseEntity {
  emailSettingsId: string;
  categoryId: string;
}

export interface IEmailSettings extends IBaseEntity {
  // Defaults
  enabled: boolean;
  defaultFromAddress: string;
  defaultReplyAddress: string;

  // Newsletter Settings
  enableNewsletter: boolean;
  newsletterSubject: string;
  newsletterFromName: string;
  newsletterIntro: string;
  newsletterArticleEnabled: boolean;
  newsletterArticleCount: number;
  newsletterPropertyEnabled: boolean;
  newsletterPropertyCount: number;
  newsletterTestimonialEnabled: boolean;
  newsletterTestimonialCount: number;

  newsletterSchedule: NewsletterSchedule;
  newsletterScheduleDayOfMonth?: number;
  newsletterScheduleTime?: string; // ISO time string

  newsletterArticleCategories: INewsletterArticleCategory[];

  // Welcome Mailer
  enableWelcomeMailer: boolean;
  welcomeMailerSubject: string;
  welcomeMailerFromName: string;

  // Property Matching
  enablePropertyMatching: boolean;
  propertyMatchingSubject: string;
  propertyMatchingFromName: string;
  propertyMatchingIntro: string;

  marketingGroups: IEmailSettingsMarketingGroup[];
  ctaBanners: IEmailSettingsCtaBanner[];

  agencyId: string;
}

export enum EmailSettingsMarketingGroupType {
  Newsletter,
  WelcomeMailer,
  PropertyMatching,
}

export interface EmailSettingsMarketingGroupUpdate {
  id?: string;
  marketingGroupId: string;
  type: EmailSettingsMarketingGroupType;
}

export interface NewsletterArticleCategoryUpdate {
  id?: string;
  categoryId: string;
}

export interface EmailSettingsCtaBannerUpdate {
  id?: string;
  ctaBannerId: string;
  order: number;
}

export interface EmailSettingsUpdate
  extends Omit<
    IEmailSettings,
    | UpdateOmitBaseEntityKeys
    | "newsletterArticleCategories"
    | "marketingGroups"
    | "ctaBanners"
  > {
  newsletterArticleCategories: NewsletterArticleCategoryUpdate[];
  marketingGroups: EmailSettingsMarketingGroupUpdate[];
  ctaBanners: EmailSettingsCtaBannerUpdate[];
}

export interface INewsletterStatistic extends INurtureCampaignRuleStatistic {}

